import { NestedGame } from "@/types/serializers"
import formatDate from "@/utils/formatDate"
import formatResult from "@/utils/formatResult"
import getGameTitle from "@/utils/getGameTitle"
import { Link } from "@inertiajs/react"

const GameItem = (game: NestedGame) => {
  const { id, result, date, chess960 } = game
  const gameTitle = getGameTitle(game)

  return (
    <Link href={`/games/${id}`} className="padding block hover:bg-gray-100">
      <li className="flex justify-between gap-x-6 py-5">
        <div className="flex min-w-0 gap-x-4">
          <div className="text-chessdrop-500 w-8 text-center text-sm leading-6 font-semibold">
            {formatResult(result ?? "*")}
          </div>
          {chess960 && (
            <span className="shrink-0 rounded bg-gray-100 px-1 text-xs font-medium text-gray-400">
              Freestyle
            </span>
          )}
          <p className="min-w-0 flex-auto truncate text-base leading-6 font-medium text-gray-900">
            {gameTitle}
          </p>
        </div>
        <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
          {date && (
            <p className="text-sm text-gray-600">
              {formatDate({
                date,
                format: "long",
              })}
            </p>
          )}
        </div>
      </li>
    </Link>
  )
}

export default GameItem
